import React from 'react'
import GradientText from './Animations/GradientText'
import BlurText from './Animations/BlurText'
import ShinyText from './Animations/ShinyText'
import SplitText from './Animations/SplitText'
import AnimatedContent from './Animations/AnimatedContent'

export default function Roadmap() {
    return (
        <div className='md:mt-[8vw] mt-[15vw] relative' id='Advantages'>
            <div className='md:w-[70%] w-[90%] mx-auto lg:pl-20 flex flex-col items-center justify-center'>
                <div className='bg-black px-5 py-1 rounded-3xl w-fit md:mb-5 mb-2'>
                    <GradientText
                        colors={["#FF6972", "#D645D0", "#01B0DF",]}
                        animationSpeed={3}
                        showBorder={false}
                        className="font-semibold md:text-lg text-sm "
                    >
                        STEPS WE FOLLOW
                    </GradientText>
                </div>
                <BlurText
                    text="The Vocal AI Advantage"
                    delay={300}
                    animateBy="words"
                    direction="top"
                    className="md:text-5xl text-3xl font-medium !text-center md:mb-5 mb-2"
                />

            </div>
            <div className='relative'>
                <img src="/images/roadmap-bg-layar.png" alt="" className='blink_animation' />
                <div className='grid lg:grid-cols-4 md:grid-cols-2 grid-cols-1 gap-5 lg:w-[80%] w-[90%] mx-auto -mt-[50vw]'>
                    <div className='lg:mt-[10vw] md:mt-0 mt-[10vw]'>
                        <AnimatedContent
                            distance={150}
                            direction="vertical"
                            reverse={false}
                            config={{ tension: 80, friction: 20 }}
                            initialOpacity={0.2}
                            animateOpacity
                            scale={1.1}
                            threshold={0.2}
                        >
                            <h1 className="text-2xl font-medium ">🌟 Smarter Tools</h1>
                        </AnimatedContent>

                        <ShinyText text=" Our advanced AI adapts to your trading style, providing real-time insights and personalized strategies."
                            disabled={false} speed={3} className='mt-5' />
                    </div>
                    <div >
                        <AnimatedContent
                            distance={150}
                            direction="vertical"
                            reverse={false}
                            config={{ tension: 80, friction: 20 }}
                            initialOpacity={0.2}
                            animateOpacity
                            scale={1.1}
                            threshold={0.2}
                        >
                            <h1 className="text-2xl font-medium ">🚀 Faster Execution</h1>
                        </AnimatedContent>


                        <ShinyText text="With voice-activated trading and ultra-fast processing, you’re always a step ahead in the market."
                            disabled={false} speed={3} className='mt-5' />
                    </div>

                    <div >
                        <AnimatedContent
                            distance={150}
                            direction="vertical"
                            reverse={false}
                            config={{ tension: 80, friction: 20 }}
                            initialOpacity={0.2}
                            animateOpacity
                            scale={1.1}
                            threshold={0.2}
                        >
                            <h1 className="text-2xl font-medium ">🔐 Unmatched Security</h1>
                        </AnimatedContent>

                        <ShinyText text=" Built on Ethereum, Vocal AI leverages blockchain technology to ensure transparency and safety."
                            disabled={false} speed={3} className='mt-5' />
                    </div>
                    <div className='lg:mt-[10vw] md:mt-0 mt-[10vw]'>
                        <AnimatedContent
                            distance={150}
                            direction="vertical"
                            reverse={false}
                            config={{ tension: 80, friction: 20 }}
                            initialOpacity={0.2}
                            animateOpacity
                            scale={1.1}
                            threshold={0.2}
                        >
                            <h1 className="text-2xl font-medium ">🤝 Accessible for All</h1>
                        </AnimatedContent>

                        <ShinyText text="Whether you’re a pro trader or a beginner, Vocal AI simplifies the complexities of crypto trading with an intuitive, voice-first approach."
                            disabled={false} speed={3} className='mt-5' />
                    </div>
                </div>
                <img src="/images/roadmap.png" alt="" className='lg:block hidden w-[60%] mx-auto -mt-[8vw]' />
                <img src="/images/glop-2.png" alt="" className='rotate_animation lg:absolute static lg:w-[40vw] w-full md:scale-100 scale-125 mx-auto md:mt-0 -mt-10 bottom-[8vw] left-[30vw]' />
            </div>

        </div>
    )
}
